import GenericTextField from "src/components/GenericTextField";
import { Autocomplete, Checkbox, CircularProgress } from "@mui/material";
import { useEffect, useState, Fragment } from "react";
import { buscarComboPorCodigo } from "src/services/api-autenticacao.service";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

function GenericAutoCompleteSelect(props) {
  const {
    codigoCombo,
    label,
    placeholder,
    value,
    replaceId = "id",
    replaceLabel = "label",
    required,
    onChange,
    error,
    helperText,
    inputRef,
    multiple,
    preSelectAll,
    noOptionsText,
    variant,
    ...rest
  } = props;

  const [open, setOpen] = useState(false);
  const [emptyListReturn, setEmptyListReturn] = useState(false);
  const [preSelectAllDone, setPreSelectAllDone] = useState(false);
  const [selectedValue, setSelectedValue] = useState(!!multiple ? [] : {});
  const [options, setOptions] = useState([]);
  const loading = true && options.length === 0 && !emptyListReturn;
  const adjustOption = (option) => {
    let opt = {};
    opt[replaceId] = option.id;
    opt[replaceLabel] = option.label;
    return opt;
  };

  const loadOptions = async (forceReload = false) => {
    let active = true;
    if ((!loading && !forceReload) || codigoCombo == null) return;
    (async () => {
      try {
        setEmptyListReturn(false);
        const response = await buscarComboPorCodigo(codigoCombo);
        const optionsList = await response.detalhes.itensCombo.map((item) => {
          const splitValues = item.split("/|/");
          return adjustOption({
            id: Number(splitValues[0]),
            label: splitValues[1],
          });
        });
        if (active) setOptions(optionsList);
        if (!!multiple && !!preSelectAll) {
          if (!preSelectAllDone) {
            onChange(optionsList);
            setPreSelectAllDone(true);
          }
        }
        if (optionsList.length === 0) setEmptyListReturn(true);
      } catch (err) {
        console.log(err);
      }
    })();
    return () => {
      active = false;
    };
  };

  useEffect(() => {
    loadOptions(true);
  }, [codigoCombo]);

  useEffect(() => {
    loadOptions();
  }, [loading]);

  useEffect(() => {
    let valueOf = value;

    if (typeof valueOf === "string") {
      valueOf = parseInt(value);
    }

    !!multiple
      ? setSelectedValue(
          options.filter((option) =>
            valueOf.some((val) => val[replaceId] === option[replaceId])
          )
        )
      : setSelectedValue(
          options.filter((option) => option[replaceId] === valueOf)[0] || {}
        );
  }, [options, value]);


  const getOptionKey = (option) => {
    if (!option || Object.keys(option).length === 0) return undefined;
    else return option[replaceId];
  };

  const getOptionLabel = (option) => {
    if (!option || Object.keys(option).length === 0) return "";
    else return option[replaceLabel];
  };

  const isOptionEqualToValue = (option, value) => {
    if (!value) return false;
    return option[replaceId] === value[replaceId];
  };

  const handleChange = (event, newValue) => {
    !!multiple ? onChange(newValue) : onChange(getOptionKey(newValue));
  };


  return (
    <Autocomplete
      {...rest}
      size={"small"}
      required={required}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      isOptionEqualToValue={isOptionEqualToValue}
      getOptionKey={getOptionKey}
      getOptionLabel={getOptionLabel}
      options={options}
      loading={loading}
      noOptionsText={noOptionsText || "Sem opções!"}
      onChange={handleChange}
      value={selectedValue}
      renderOption={(props, option, { selected }) => (
        <li {...props} style={{
          margin: "0px",
          padding: "4px"
        }}>
          {!!multiple && (
            <Checkbox
              size={"small"}
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              style={{
                margin: "0px",
                marginRight: "8px",
                padding: "0px",
              }}
              checked={selected}
            />
          )}
          <span style={{ fontSize: "14px" }}>{option[replaceLabel]}</span>
        </li>
      )}
      renderInput={(params) => (
        <GenericTextField
          label={(label)
            ? label.concat(required ? " *" : "")
            : undefined
          }
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          variant={variant}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </Fragment>
            ),
          }}
          {...params}
        />
      )}
      multiple={multiple}
      disableCloseOnSelect={multiple}
      ref={inputRef}
    />
  );
}

export default GenericAutoCompleteSelect;
